<template>
    <div
        :class="meauLeft ? 'exam-sailfish first-item item-list-on-left' : 'exam-sailfish first-item item-list-on-left fold-item-list'">
        <div class="header">
            <div class="h_left">
                <div class="h_img">
                    <img src="https://www.yitku.com/mock/account_7.png">
                </div>
                <div class="h_text">
                    <div class="h_txt">姓名：XXX</div>
                    <div class="h_txt">性别：X</div>
                    <div class="h_txt">准考证号：1111111111</div>
                    <div class="h_txt">证件号码：1111111111</div>
                </div>
            </div>
            <div class="h_center">
                全国会计专业技术初级资格考试 {{ mecoTitle }}（演示版）
            </div>
            <div class="h_right">
                <div class="h_time"> 科目剩余时间：{{ countSecond }}</div>
                <div class="h_subject"> {{ mecoTitle }}：科目作答中</div>
            </div>
            <div class="h_btns" @click="submitPaper">交卷</div>
        </div>
        <div class="item-list">
            <div class="item-list-cont">
                <button class="btn-folder" @click="showMeauLeft">
                    <i class="el-icon-arrow-left" v-if="meauLeft"></i>
                    <i class="el-icon-arrow-right" v-else></i>
                </button>
                <div class="wrap-item-num-list">
                    <div class="wrap-navigation-tip"></div>
                    <div class="ng-star-inserted" v-if="jsonData.judge > 0">
                        <div class="wrap-group-name clearfix" @click="judgeChange">
                            <span class="rb_nav_title">
                                <span class="group-name ml-2">判断题</span>
                                <i :class="judge == 0 ? 'el-icon-arrow-down' : 'el-icon-arrow-right'"></i>
                            </span>
                        </div>
                        <ul class="item-num-list clearfix mt-2 ng-star-inserted"
                            :style="judge == 1 ? 'display:none;' : ''">
                            <li @click="nextQuestion(item)"
                                :class="index == item ? 'mb-2 current' : questionData[item - 1].user_answer ? 'mb-2' : ' mb-2'"
                                v-for="item in jsonData.judge" :key="item">
                                <span class="num-val">{{ item }}
                                    <span style="color: red;margin-left: 2px;"
                                        v-if="questionData[item - 1].mark == true">?</span>
                                    <span style="color: red;margin-left: 2px;"
                                        v-else-if="questionData[item - 1].user_answer == ''">*</span>
                                </span>
                                <!-- <span v-if="questionData[item - 1].mark == true" class="marked"></span> -->
                            </li>
                        </ul>
                    </div>
                    <div class="ng-star-inserted" v-if="jsonData.radio > 0">
                        <div class="wrap-group-name clearfix" @click="radioChange">
                            <span class="rb_nav_title">
                                <span class="group-name ml-2">单选题</span>
                                <i :class="radio == 0 ? 'el-icon-arrow-down' : 'el-icon-arrow-right'"></i>
                            </span>
                        </div>
                        <ul class="item-num-list clearfix mt-2 ng-star-inserted"
                            :style="radio == 1 ? 'display:none;' : ''">
                            <li @click="nextQuestion(jsonData.judge + item)"
                                :class="index == (jsonData.judge + item) ? 'mb-2 current' : questionData[(jsonData.judge + item) - 1].user_answer ? 'mb-2' : ' mb-2'"
                                v-for="item in jsonData.radio" :key="item">
                                <span class="num-val">{{ item }}
                                    <span style="color: red;margin-left: 2px;"
                                        v-if="questionData[jsonData.judge + item - 1].mark == true">?</span>
                                    <span style="color: red;margin-left: 2px;"
                                        v-else-if="questionData[(jsonData.judge + item) - 1].user_answer == ''">*</span>
                                </span>
                            </li>
                        </ul>
                    </div>
                    <div class="ng-star-inserted" v-if="jsonData.checkbox > 0">
                        <div class="wrap-group-name clearfix" @click="checkboxChange">
                            <span class="rb_nav_title">
                                <span class="group-name ml-2">多选题</span>
                                <i :class="checkbox == 0 ? 'el-icon-arrow-down' : 'el-icon-arrow-right'"></i>
                            </span>
                        </div>
                        <ul class="item-num-list clearfix mt-2 ng-star-inserted"
                            :style="checkbox == 1 ? 'display:none;' : ''">
                            <li @click="nextQuestion(jsonData.judge + jsonData.radio + item)"
                                :class="index == (jsonData.judge + jsonData.radio + item) ? 'mb-2 current' : questionData[(jsonData.judge + jsonData.radio + item) - 1].user_answer ? 'mb-2' : ' mb-2'"
                                v-for="item in jsonData.checkbox" :key="item">
                                <span class="num-val">{{ item }}
                                    <span style="color: red;margin-left: 2px;"
                                        v-if="questionData[jsonData.judge + jsonData.radio + item - 1].mark == true">?</span>
                                    <span style="color: red;margin-left: 2px;"
                                        v-else-if="questionData[(jsonData.judge + jsonData.radio + item) - 1].user_answer == ''">*</span>
                                </span>
                            </li>
                        </ul>
                    </div>
                    <div class="ng-star-inserted" v-if="jsonData.indefinite > 0">
                        <div class="wrap-group-name clearfix" @click="indefiniteChange">
                            <span class="rb_nav_title">
                                <span class="group-name ml-2">不定项</span>
                                <i :class="indefinite == 0 ? 'el-icon-arrow-down' : 'el-icon-arrow-right'"></i>
                            </span>
                        </div>
                        <ul class="item-num-list clearfix mt-2 ng-star-inserted"
                            :style="indefinite == 1 ? 'display:none;' : ''">
                            <li @click="nextQuestion(jsonData.judge + jsonData.radio + jsonData.checkbox + item)"
                                :class="index == (jsonData.judge + jsonData.radio + jsonData.checkbox + item) ? 'mb-2 current' : questionData[(jsonData.judge + jsonData.radio + jsonData.checkbox + item) - 1].user_answer ? 'mb-2' : ' mb-2'"
                                v-for="item in jsonData.indefinite" :key="item">
                                <span class="num-val">{{ item }}
                                    <span style="color: red;margin-left: 2px;"
                                        v-if="questionData[jsonData.judge + jsonData.radio + jsonData.checkbox + item - 1].mark == true">?</span>
                                    <span style="color: red;margin-left: 2px;"
                                        v-else-if="questionData[(jsonData.judge + jsonData.radio + jsonData.checkbox + item) - 1].user_answer == ''">*</span>
                                </span>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="item-note">
                    <div class="note-text"> 说明:</div>
                    <div class="note-text"> 1.题号右方的“ * ”符号代表该小题尚未选择答案。</div>
                    <div class="note-text"> 2.题号右方的“ ? ”符号代表该小题做过标记。</div>
                    <div class="note-text"> 3.选择选项的同时自动保存答案。</div>
                    <div class="note-jsq" @click="openCalculator">
                        <img src="https://www.yitku.com/mock/account_1.png">
                    </div>
                    <!-- <ul class="item-note-list">
                        <li>
                            <div class="icon-item-note current"><span class="num-val"></span></div>
                            <div>当前</div>
                        </li>
                        <li>
                            <div class="icon-item-note undo"><span class="num-val"></span></div>
                            <div>未完成</div>
                        </li>
                        <li>
                            <div class="icon-item-note done"><span class="num-val"></span></div>
                            <div>已完成</div>
                        </li>
                        <li>
                            <div class="icon-item-note markeds"><span class="num-val"></span></div>
                            <div>标记</div>
                        </li>
                    </ul> -->
                </div>
            </div>
            <div class="mask-for-mobile"></div>
        </div>
        <div class="rt-content">
            <div class="rt_title">
                <div class="rt_title_span">试卷</div>
            </div>
            <div class="wrap-group-name pl-3 pr-3 ng-star-inserted">
                <div class="group-name-cont-left" v-if="question.type == 0">
                    <!-- <div class="group-name font-weight-bold ng-star-inserted">判断题</div> -->
                    <div class="group-description pb-1 font-weight-bold ng-star-inserted">
                        三、判断题(本类题共{{ jsonData.judge }}小题，每小题1分，共10分。请判断每小题的表述是否正确。每小题答题正确的得1分，错答、不答均不得分，也</div>
                </div>
                <div class="group-name-cont-left" v-if="question.type == 1">
                    <!-- <div class="group-name font-weight-bold ng-star-inserted">单选题</div> -->
                    <div class="group-description pb-1 font-weight-bold ng-star-inserted">
                        一、单项选择题(本类题共{{ jsonData.radio }}小题，每小题2分，共46分。每小题备选答案中，只有一个符合题意的正确答案。错选、不选均不得分。请使</div>
                </div>
                <div class="group-name-cont-left" v-if="question.type == 2">
                    <!-- <div class="group-name font-weight-bold ng-star-inserted">多选题</div> -->
                    <div class="group-description pb-1 font-weight-bold ng-star-inserted">
                        二、多项选择题(本类题共{{ jsonData.checkbox }}小题，每小题2分，共20分。每小题备选答案中，有两个或两个以上符合题意的正确答案。请至少选择两个答</div>
                </div>
                <div class="group-name-cont-left" v-if="question.type == 4">
                    <!-- <div class="group-name font-weight-bold ng-star-inserted">多选题</div> -->
                    <div class="group-description pb-1 font-weight-bold ng-star-inserted">
                        四、不定项选择题（本类题共{{ jsonData.indefinite * 5
                        }}小题，每小题2分，共24分。每小题备选答案中，有一个或一个以上符合题意的正确答案。每小题全部选对得满分，少选得相应分值，多选、错选、不选均不得分。请使用计算机鼠标在计算机答题界面上点击试题答案备选项前的按钮“□”作答。）
                    </div>
                </div>
                <div class="group-name-cont-right"></div>
            </div>
            <div class="rt-cont-main">
                <div class="wrap-item">
                    <div id="item-area" class="main-cont cont">
                        <div class="item item-tf">
                            <div class="wrap-item-cont zoom-cont pr-3 pt-2 pb-2" v-if="question.type != 4">
                                <div class="item-head pt-2 pb-3 clearfix" style="flex-direction:column;">
                                    <span class="item-prop"><i class="item-index">第{{ index }}题</i></span>
                                    <div class="item-stem">
                                        <div v-html="question.title"></div>
                                    </div>
                                </div>
                                <div class="item-cont sub-answer">

                                    <ul class="topic_li" v-if="question.type == 1 || question.type == 0">
                                        <el-radio-group v-model="radioValue" @input="selectRadio"
                                            class="vertical-radio-group">
                                            <el-radio :label="item.key" v-for="(item, idx) in question.select_list"
                                                :key="idx">{{ item.key + '.' + item.value }}</el-radio>
                                        </el-radio-group>
                                    </ul>

                                    <ul class="topic_li" v-if="question.type == 2 || question.type_id == 2">
                                        <el-checkbox-group v-model="checkList" @change="selectCheck"
                                            class="vertical-radio-group">
                                            <el-checkbox :label="item.key" v-for="(item, idx) in question.select_list"
                                                :key="idx">{{ item.key + '.' + item.value }}</el-checkbox>
                                        </el-checkbox-group>
                                    </ul>

                                </div>
                            </div>

                            <div class="wrap-item-cont zoom-cont pr-3 pt-2 pb-2" v-else>
                                <div class="item-head pt-2 pb-3 clearfix" style="flex-direction:column;">
                                    <span class="item-prop"><i class="item-index">第{{ index }}题</i></span>
                                    <div class="item-stem-type">
                                        <div class="top" v-html="question.title"></div>
                                        <div class="bottom">
                                            <div class="bottom_li" v-for="(itemes, idxx) in question.q">
                                                <div class="bottom_title">{{ idxx + 1 }}、{{ itemes.title }}</div>
                                                <ul class="topic_li" v-if="itemes.type_id == 1 || itemes.type == 0">
                                                    <el-radio-group v-model="itemes.user_answer"
                                                        @input="selectRadio($event, idxx)" class="vertical-radio-group">
                                                        <el-radio :label="item1.key"
                                                            v-for="(item1, idx1) in itemes.select_list" :key="idx1">{{
                                                                item1.key + '.' + item1.value }}</el-radio>
                                                    </el-radio-group>
                                                </ul>
                                                <ul class="topic_li" v-if="itemes.type_id == 2">
                                                    <el-checkbox-group v-model="itemes.user_answer"
                                                        @change="selectCheck($event, idxx)"
                                                        class="vertical-radio-group">
                                                        <el-checkbox :label="item1.key"
                                                            v-for="(item1, idx1) in itemes.select_list" :key="idx1">{{
                                                                item1.key + '.' + item1.value }}</el-checkbox>
                                                    </el-checkbox-group>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="wrap-tag-bar">
            <div class="tag-bar">
                <div class="wrap-btn-submit pl-3 pr-3">
                    <!-- <button class="yk-btn-primary w-100" @click="submitPaper">
                        <span>交卷</span>
                    </button> -->
                </div>
                <div class="btn-mark-item text-primary">
                    <div :class="question.mark ? 'icon-mark ml-3 mark-active' : 'icon-mark ml-3'" @click="openMark">
                        <i class="el-icon-collection-tag"></i>
                        <span class="txt-pc mark-txt text-sub" v-if="question.mark == false">标记本题</span>
                        <span class="txt-pc mark-txt text-sub" v-else>取消标记</span>
                    </div>
                </div>
                <div class="wrap-next-prev-btn">
                    <span class="btn-prev-item ng-star-inserted" v-if="index != 1">
                        <button class="yk-btn-primary btn-min-width" @click="nextQuestion(index - 1)">
                            <i class="el-icon-arrow-left"></i>
                            <span>上一题</span>
                        </button>
                    </span>
                    <span class="btn-next-item" v-if="index != total">
                        <button class="yk-btn-primary btn-min-width" @click="nextQuestion(index + 1)">
                            <span>下一题</span>
                            <i class="el-icon-arrow-right"></i>
                        </button>
                    </span>
                </div>
            </div>
        </div>

        <el-dialog title="科学计算器" :modal="false" :modal-append-to-body="false" :close-on-click-modal="false" v-dialogDrag
            :visible.sync="dialogVisible" width="720px" :before-close="handleClose">
            <iframe src="https://www.yitku.com/calc" frameborder="0" width="100%" height="350"></iframe>
        </el-dialog>

        <div id="full" class="block_overlay" v-if="showDialog"></div>
        <div id="content" class="div_content" v-if="showDialog">
            <div class="dialog_main">
                <div class="dialog_content">
                    <div class="dialog_text" v-if="showType == 0">
                        此为本科目最后一题！
                    </div>
                    <div class="dialog_text" v-if="showType == 1">
                        <p>【初级会计实务】尚未作答。</p>
                        <p>请确定全部答完后交卷！</p>
                    </div>
                    <div class="dialog_text" v-if="showType == 2">
                        <p>【初级会计实务】尚有{{ nums }}道题未作答。</p>
                        <p>交卷后将不能返回本科目作答，确定继续交卷吗？</p>
                    </div>
                    <div class="dialog_text" v-if="showType == 3">
                        <p>再次确认是否交卷？</p>
                        <p>交卷后将不能返回本科目作答！</p>
                    </div>
                    <div class="dialog_btn">
                        <div class="dialog_button" @click="backDoExam()">返回作答</div>
                        <div @click="submitDoExam()" v-if="showType == 2 || showType == 3" class="dialog_button">确定交卷
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
export default {
    data() {
        return {
            showDialog: false,
            fullscreenLoading: false,
            code: "",
            txt: "",
            showCode: 0,
            showType: 0,
            isPause: true,
            showSubmitSuccess: false,
            dialogOutVisible: false,
            dialogVisible: false,
            checked: 0,
            isAuto: false,
            nTitle: "考生须知",
            meauLeft: true,
            showSeeting: false,
            // 倒计时-时
            hour: "",
            // 倒计时-分
            min: "",
            // 倒计时-秒
            second: "",
            // 倒计时-时间
            countSecond: "",
            // 结束日期
            endDate: new Date().getTime(),
            jsonData: [],
            questionData: [],
            question: [],
            checkList: [],
            index: 1,
            nums: 0,
            pc_id: 0,
            times: 0,
            isAuto: 1,
            total: 0,
            radioValue: 0,
            checkbox: 0,
            judge: 0,
            radio: 0,
            indefinite: 0,
            fininsh: 0,
            mecoId: sessionStorage.getItem("access-mecoId"),
            column_id: sessionStorage.getItem("access-column_id"),
            mecoTitle: sessionStorage.getItem("access-mecoTitle"),
            paper_id: 0,
        };
    },
    mounted: function () {
        var that = this;
        var query = that.$route.query;
        if (query.paper_id) {
            that.paper_id = query.paper_id;
        }
        this.getList();
    },
    methods: {

        handleClose() {
            this.dialogVisible = false;
        },

        openCalculator() {
            this.dialogVisible = true;
        },

        clickPause() {
            this.isPause = !this.isPause;
        },

        backDoExam() {
            this.showDialog = false;
        },

        submitDoExam() {
            if (this.showType == 2) {
                this.showType = 3
            } else {
                this.confirmSubmit();
            }
        },

        radioChange() {
            this.radio = !this.radio;
        },

        checkboxChange() {
            this.checkbox = !this.checkbox;
        },

        judgeChange() {
            this.judge = !this.judge;
        },

        indefiniteChange() {
            this.indefinite = !this.indefinite;
        },

        setSeeting() {
            this.showSeeting = !this.showSeeting;
        },

        getList() {
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            let that = this;
            let formData = {};
            formData.column_id = that.column_id;
            formData.subject_id = that.mecoId;
            formData.paper_id = that.paper_id;
            that.axios.post("/getPaperAccount", formData).then((res) => {
                console.log(res.data);
                if (res) {
                    let jsonPaper = res.data;
                    that.total = jsonPaper.nums;
                    that.fininsh = jsonPaper.pc;
                    that.jsonData = jsonPaper;
                    that.times = jsonPaper.pc_times;
                    that.questionData = jsonPaper.lists;
                    that.question = jsonPaper.lists[0];
                    this.radioValue = jsonPaper.lists[0].user_answer;
                    that.endDate = that.endDate + jsonPaper.stime * 60 * 1000 - jsonPaper.pc_times * 1000;
                    that.setPcPaper(jsonPaper.id);
                    that.countTime();
                    loading.close();
                    //that.pc = res.data.pc;
                    //that.pc_id = res.data.pc_id;
                    //sessionStorage.setItem("access-mecoPapers", JSON.stringify(res.data));
                }
            });
        },

        selectRadio(e, idx = 0) {
            let _this = this;
            let json = this.questionData;
            let right = 0;
            if (this.question.type == 4) {
                json[this.index - 1].user_answer = e;
                json[this.index - 1].user_answer_right = 0;
                this.questionData = json;
                console.log(this.question);

                if (this.question['q'][idx].answer == e) {
                    right = 1;
                }
                let formData = {};
                formData.pc_id = this.pc_id;
                formData.paper_id = this.question.p_id;
                formData.question_id = this.question['q'][idx].id;
                formData.user_answer_right = right;
                formData.user_answer = e;
                formData.times = this.times;
                console.log(formData);
                this.axios.post("/setPcQuestion", formData).then((res) => {
                    _this.fininsh = res.data;
                });
            } else {
                json[this.index - 1].user_answer = e;
                if (this.question.answer == e) {
                    right = 1;
                }
                json[this.index - 1].user_answer_right = right;
                let formData = {};
                this.questionData = json;
                formData.pc_id = this.pc_id;
                formData.paper_id = this.question.p_id;
                formData.question_id = this.question.id;
                formData.user_answer_right = right;
                formData.user_answer = e;
                formData.times = this.times;
                this.axios.post("/setPcQuestion", formData).then((res) => {
                    if (_this.isAuto == 1) {
                        _this.nextQuestion(_this.index + 1);
                    }
                    _this.fininsh = res.data;
                });
            }
        },

        selectCheck(e, idx = 0) {
            console.log(e);
            let es = e.sort();
            let string = es.join("");
            let json = this.questionData;
            let right = 0;
            if (this.question.type == 4) {
                json[this.index - 1].user_answer = string;
                json[this.index - 1].user_answer_right = 0;
                this.questionData = json;
                if (this.question['q'][idx].answer == string) {
                    right = 1;
                }
                let formData = {};
                formData.pc_id = this.pc_id;
                formData.paper_id = this.question.p_id;
                formData.question_id = this.question['q'][idx].id;
                formData.user_answer_right = right;
                formData.user_answer = string;
                formData.times = this.times;
                this.axios.post("/setPcQuestion", formData).then((res) => {
                    this.fininsh = res.data;
                });
            } else {
                json[this.index - 1].user_answer = string;
                let right = 0;
                if (this.question.answer == string) {
                    right = 1;
                }
                json[this.index - 1].user_answer_right = right;
                this.questionData = json;
                let formData = {};
                this.questionData = json;
                console.log(this.questionData);
                formData.pc_id = this.pc_id;
                formData.paper_id = this.question.p_id;
                formData.question_id = this.question.id;
                formData.user_answer_right = right;
                formData.user_answer = string;
                formData.times = this.times;
                this.axios.post("/setPcQuestion", formData).then((res) => {
                    this.fininsh = res.data;
                });
            }
        },

        //创建记录
        setPcPaper(ids) {
            let that = this;
            let formData = {};
            formData.paper_id = ids;
            that.axios.post("/setPcPaper", formData).then((res) => {
                that.pc_id = res.data;
            });
        },

        //提交试卷
        confirmSubmit() {
            let that = this;
            let formData = {};
            formData.pc_id = that.pc_id;
            formData.times = that.times;
            formData.question = that.questionData;
            that.axios.post("/setSubmitAccount", formData).then((res) => {
                //this.showSubmitSuccess = true;
                that.leftTime = 0;
                that.$router.push({
                    path: "/guide/account/success",
                    query: {
                        pc_id: that.pc_id,
                        column_id: that.jsonData.column_id,
                    },
                });
            });
        },

        openMark() {
            let json = this.questionData;
            json[this.index - 1].mark = !json[this.index - 1].mark;
            this.questionData = json;
        },

        //点击题号显示对应的题
        nextQuestion(ids) {
            console.log(ids);
            if (ids > this.questionData.length) {
                this.showDialog = true;
                this.showType = 0;
                return false;
            }

            this.radioValue = "";
            this.checkList = [];
            let index = ids - 1;
            this.index = ids;
            this.question = this.questionData[index];
            if (ids <= 0) {
                return false;
            }
            //console.log(ids);
            //console.log(this.questionData.length);
            if (ids > this.questionData.length) {
                console.log(this.question.user_answer);
                if (this.question.type == 1 || this.question.type_id == 1 || this.question.type == 0) {
                    this.radioValue = this.question.user_answer;
                }
                alert("已经是最后一题了");
            } else {
                if (this.question.type == 1 || this.question.type_id == 1 || this.question.type == 0) {
                    this.radioValue = this.question.user_answer;
                } else if (this.question.type == 2 || this.question.type_id == 2) {
                    this.checkList = this.question.user_answer.split("");
                } else if (this.question.type == 4) {
                    this.question.q.forEach((item, index) => {
                        if (item.type_id == 2) {
                            if (item.user_answer) {
                                this.question.q[index].user_answer = item.user_answer.split("");
                            } else {
                                this.question.q[index].user_answer = [];
                            }
                        }
                    });
                    console.log(this.question.q);
                }
            }
        },

        // 倒计时
        countTime() {
            let now = new Date().getTime(); // 获取当前时间
            let endDate = new Date(this.endDate); // 设置截止时间
            let end = Number(endDate);
            //let endDate = new Date(this.assistActivityEndTime); // this.assistActivityEndTime需要倒计时的日期
            let leftTime = end - now; // 倒计时时间差
            // 定义变量 d,h,m,s保存倒计时的时间
            if (leftTime >= 0) {
                // 天
                // this.day = Math.floor(leftTime / 1000 / 60 / 60 / 24);
                // let dayh = this.day * 24
                let h = Math.floor((leftTime / 1000 / 60 / 60) % 24);
                h = h;
                this.hour = h < 10 ? "0" + h : h;
                // 分
                let m = Math.floor((leftTime / 1000 / 60) % 60);
                this.min = m < 10 ? "0" + m : m;
                // 秒
                let s = Math.floor((leftTime / 1000) % 60);
                this.second = s < 10 ? "0" + s : s;
                this.countSecond = this.hour + ":" + this.min + ":" + this.second;
            } else {
                this.day = 0;
                this.hour = "00";
                this.min = "00";
                this.second = "00";
                this.countSecond = this.hour + ":" + this.min + ":" + this.second;
                //this.min = 0;
                return false;
                //this.confirmSubmit();
            }
            // 等于0的时候不调用
            if (
                Number(this.day) === 0 &&
                Number(this.hour) === 0 &&
                Number(this.min) === 0 &&
                Number(this.second) === 0
            ) {
                this.$route.query.count = 4;
                // 执行飞行任务
                this.confirmSubmit();
                return;
            } else {
                // 递归每秒调用countTime方法，显示动态时间效果,
                this.times = this.times + 1;
                setTimeout(this.countTime, 1000);
                // if (this.isPause == true) {
                //     setTimeout(this.countTime, 1000);
                //     //console.log(this.times);
                //     this.jsonData.pc_times = this.times;
                //     sessionStorage.setItem('access-mecoPapers', JSON.stringify(this.jsonData));
                // }
            }
        },

        showMeauLeft() {
            this.meauLeft = !this.meauLeft;
            console.log(this.meauLeft);
        },


        submitPaper() {
            let num = 0;
            this.questionData.forEach((element) => {
                if (element.user_answer_right != -1) {
                    num++;
                }
            });
            this.nums = this.questionData.length - num;
            //console.log(this.nums);
            //this.dialogOutVisible = true;
            this.showDialog = true;
            if (this.nums == this.questionData.length) {
                this.showType = 1;
            } else if (this.nums == 0) {
                this.showType = 3;
            } else {
                this.showType = 2;
            }
        },

    },
};
</script>


<style>
@import "../../../../public/css/account.css";

.block_overlay {
    position: absolute;
    top: 0%;
    left: 0%;
    width: 100%;
    height: 100%;
    background-color: grey;
    z-index: 100;
    filter: alpha(opacity=80);
    -moz-opacity: 0.8;
    opacity: 0.8;
}

.div_content {
    position: absolute;
    top: 36%;
    left: 36%;
    width: 526px;
    height: 291px;
    z-index: 101;
}

.dialog_main {
    background: url('https://www.yitku.com/mock/account_6.png') no-repeat;
    height: 291px;
    width: 526px;
    background-size: 100%;
}

.dialog_content {
    float: left;
    margin: 110px auto auto 190px;
    width: 60%;
}

.dialog_text {
    color: #ff0000;
    font-size: 16px;
    font-weight: bolder;
    line-height: 28px;
}

.dialog_btn {
    margin-top: 35px;
    margin-left: 54px;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
}

.dialog_button {
    width: 70px;
    height: 26px;
    background: linear-gradient(180deg, #FFD7B3, #F9A252, #C46204);
    font-size: 12px;
    color: #fff;
    line-height: 26px;
    text-align: center;
    border-radius: 3px;
    font-weight: bold;
    cursor: pointer;
    margin-left: 10px;
}

.sub-answer dd i {
    background: url(https://www.jianjiangedu.cn/home/img/pra_icon.png) no-repeat;
}

.sub-answer {
    font-size: 18px;
    padding: 0 10px 15px 0;
    clear: both;
    background: url(https://www.yitku.com/home/img/logo_white.png) no-repeat center;
    position: relative;
    cursor: pointer;
    min-height: 200px;
}

.sub-answer dd {
    display: block;
    padding: 10px 0 10px 40px;
    margin-left: -20px;
    font-size: 18px;
    line-height: 24px;
    color: #151515;
    position: relative;
    cursor: pointer;
}

.sub-answer dd i {
    width: 21px;
    height: 25px;
    display: block;
    background-position: -19px -58px;
    position: absolute;
    top: 8px;
    left: 5px;
}

.sub-answer-double dd i {
    background-position: 0 -562px;
}

.sub-answer dd span {
    color: #333;
    margin-right: 5px;
    top: 7px;
    left: 40px;
}

.btn-min-width span {
    margin-left: 5px;
    margin-right: 5px;
}

.vertical-radio-group {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    line-height: 36px;
}

.vertical-radio-group span {
    font-size: 16px;
}

.vertical-radio-group label {
    line-height: 36px;
    font-size: 16px;
}



.student-pause-exam {
    height: 100%;
    width: 100%;
    position: fixed;
    top: 0;
    background: url(https://demo.joytest.org/client/bg-img.b09cff364b6ff09a.png) #f0f5ff no-repeat center bottom;
    background-size: 100% auto;
    left: 0;
    z-index: 9998;
    margin: 0;
    padding: 150px 0 30px;
}

.wrap-entry-block .session-title {
    padding: 0 50px 15px;
    font-size: 30px;
    text-align: center;
    padding: 0 6rem 15px;
    line-height: 1.5;
    font-weight: 700;
}

.student-pause-exam .pause-exam-login {
    height: auto;
    border-radius: 5px;
    padding: 50px;
}

.wrap-entry-block .sign-in,
.wrap-entry-block .pause-exam-login {
    max-width: 900px;
    width: 90%;
}

.wrap-entry-block .entry-block {
    background: var(--ac-bg, #fff);
    box-shadow: 0 0 20px #abb2db80;
    overflow: hidden;
    margin: 0 auto;
    position: relative;
    border-radius: 10px;
}

.leave {
    margin-bottom: 35px;
    justify-content: center;
}

.d-flex {
    display: flex !important;
}

.student-pause-exam .entry-sub-title {
    color: #8c92ac !important;
}

.wrap-entry-block .entry-sub-title {
    margin: 0 auto 30px;
    font-size: 18px;
    font-weight: 700;
    color: #fff;
}

.text-center {
    text-align: center !important;
}

.student-pause-exam .time-left {
    font-size: 14px;
    height: 28px;
    background-color: #8c92ac;
    margin-left: 20px;
    border-radius: 4px;
    line-height: 28px;
    padding: 0 15px;
    color: #fff;
}

.student-pause-timer .wrap-timer-cont,
.student-pause-timer .wrap-timer-cont {
    background-color: #8c92ac;
}

.wrap-timer-cont {
    font-size: 14px;
    display: inline-block;
    border-radius: 50px;
    background-color: #fff;
    height: 26px;
    overflow: hidden;
    vertical-align: bottom;
}

.text-danger {
    color: var(--ac-color, #dc3545) !important;
    line-height: 40px;
    height: 40px;
}

.temporary-leave {
    cursor: pointer;
    border: 1px solid #fff;
    border-radius: 5px;
    padding: 3px 8px;
}

.rt_title {
    height: 36px;
    line-height: 36px;
    border-bottom: 1px solid #1565A8;
    margin-top: 10px;
}

.rt_title .rt_title_span {
    font-size: 16px;
    width: 92px;
    height: 35px;
    background: linear-gradient(0deg, #498FC5 0%, #79BEED 88%, #DDEBF6 100%);
    border-radius: 2px 2px 0px 0px;
    border: 1px solid;
    border-image: linear-gradient(0deg, #1464A7, #418ED1) 10 10;
    text-align: center;
    font-weight: bold;
}

.rb_nav_title {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 100%;
}

.item-note {
    padding: 10px 20px 10px 20px;
}

.note-text {
    font-size: 12px;
    color: #dc3545;
    line-height: 20px;
}

.note-jsq {
    position: absolute;
    right: 5px;
    bottom: 5px;
    cursor: pointer;
}

.note-jsq img {
    width: 90px;
    height: 33px;
}

.item-stem-type {
    width: 100%;
    display: flex;
    flex-direction: row;
}

.item-stem-type .top {
    width: 40%;
    height: 500px;
    overflow: auto;
    border-right: 5px solid #9fb7f7;
    padding: 0 10px;
    line-height: 28px;
}

.item-stem-type .bottom {
    width: 56%;
    height: 500px;
    overflow: auto;
    padding: 0 20px;
    line-height: 28px;
}

.item-stem-type .bottom .bottom_li {
    margin-bottom: 10px;
}

.item-stem-type .bottom .topic_li {
    padding-left: 20px;
}
</style>
